import React from 'react';
import { connect } from 'react-redux';
import { Route, withRouter, Redirect } from 'react-router-dom';
import firebase from 'firebase';
import { Loader } from 'semantic-ui-react';

import { firebaseConfig } from '../config';
import { signOut } from '../actions';
import Home from './Home';
import Dashboard from './Dashboard';
import SignIn from '../components/Auth/SignIn';
import SignUp from '../components/Auth/SignUp';


const ProtectedRoute = ({ component: Component, authed, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => authed === true 
      ? <Component {...props} />
      : <Redirect to={{ pathname: '/signIn', state: { from: props.location }}} />}
    />
  );
}

const PublicRoute = ({ component: Component, authed, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => authed === false 
      ? <Component {...props} />
      : <Redirect to='/' />}
    />
  );
}


class App extends React.Component {

  state = { loggedIn: false, loading: true }

  componentDidMount() {
    firebase.initializeApp(firebaseConfig);
    firebase.auth().onAuthStateChanged((user) => {
      if (user !== null) {
        // Pull user info here
        this.getUserInfo(user);
      } else {
        this.setState({ loggedIn: false, loading: false });
      }
    });

    this.updatePayments();

  }

  updatePayments () {
    fetch('https://us-central1-zuzu-51286.cloudfunctions.net/updatePayments ');
  }

  getUserInfo (user) {
    var users = firebase.database().ref('user');
    users.orderByChild('uid').equalTo(user.uid).once('value', (data) => {
      var object = data.val();
      for (var key in object) {
        if (object.hasOwnProperty(key)) {
          object = object[key];
        }
      }
      localStorage.setItem("currentUser", object.uid);
      if(object.isAdmin !== true) localStorage.setItem("type", object.type);
      if(object.isAdmin === true) localStorage.setItem("type", "admin");
      if(object.type === 'business' && object.stripe && object.stripe.account) localStorage.setItem("customer_id", object.stripe.customer_id);
      if(object.type === 'user' && object.stripe && object.stripe.account) localStorage.setItem("account_id", object.stripe.account.id);
      if(object.type === 'user') localStorage.setItem("userKey", object.userKey);

      // If user type is business and they have a pin set, then ask the user for a valid pin otherwise don't allow access to the application.
      if(object.type === 'business' && object.pin) {
        this.askUserForPin(object);
      } else {
        this.setState({ loggedIn: true, loading: false });
      }
      
    });
    
  }

  askUserForPin (object) {
    var pin = window.prompt("Enter your PIN","");

    if (pin === object.pin) {
      this.setState({ loggedIn: true, loading: false });
    } else {
      this.askUserForReminder(object);
    }

  }

  askUserForReminder (userData) {
    const sendPinReminder = window.confirm('Invalid pin. Would you like a reminder sent to your email?');
    if (sendPinReminder) {
      userData.resetPin = Date.now();
      let refUser = firebase.database().ref('user').child(userData.userKey).update(userData);
      if (refUser) {
        alert("An email has been sent to you containing your pin.");
        this.props.signOut();
      }
    } else {
      this.askUserForPin(userData);
    }
  }

  render()  {
    if (this.state.loading) {
      return <Loader />;
    } else {
      return (
        <div>
          <Route exact path='/welcome' component={Home} />
          <PublicRoute authed={this.state.loggedIn} path='/signIn' component={SignIn} />
          <PublicRoute authed={this.state.loggedIn} path='/signUp' component={SignUp} />
          <ProtectedRoute authed={this.state.loggedIn} path='/' component={Dashboard} />           
        </div>
      )
    }
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth
});

/**
 *  withRouter is a HOC to work around the issue of connect() conflict 
 *  with the current version of React Router.
 *  This might change in future releases
 */

export default withRouter(connect(mapStateToProps, {signOut})(App));


// WEBPACK FOOTER //
// ./src/containers/App.js